import React from "react";
import { IconProps } from "@src/lib/icons/types";

const PromptTypeTrueFalseIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="19"
        height="18"
        fill="none"
        viewBox="0 0 19 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 1.75C5.49594 1.75 2.25 4.99594 2.25 9C2.25 13.0041 5.49594 16.25 9.5 16.25V1.75Z"
          fill={color}
          fillOpacity="0.2"
        />
        <path
          d="M9.5 1.75V16.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 16.25C13.5041 16.25 16.75 13.0041 16.75 9C16.75 4.99594 13.5041 1.75 9.5 1.75C5.49594 1.75 2.25 4.99594 2.25 9C2.25 13.0041 5.49594 16.25 9.5 16.25Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default PromptTypeTrueFalseIcon;
